import React from 'react'

interface Estado { erro: Error | null }

/**
 * Se uma tela quebrar ao desenhar, mostra o aviso no lugar dela em vez de deixar a
 * página em branco, e o menu continua funcionando. Volta ao normal ao trocar de tela.
 */
export default class ProtecaoDeTela extends React.Component<{ chave: string; children: React.ReactNode }, Estado> {
  state: Estado = { erro: null }

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro }
  }

  componentDidCatch(erro: Error, info: React.ErrorInfo) {
    console.error('[portal novo] A tela quebrou ao desenhar', erro, info.componentStack)
  }

  componentDidUpdate(anteriores: { chave: string }) {
    if (anteriores.chave !== this.props.chave && this.state.erro) this.setState({ erro: null })
  }

  render() {
    if (!this.state.erro) return this.props.children
    return (
      <div className="np-tela-quebrou" role="alert">
        <h2>Esta tela não abriu</h2>
        <p>Pode ser uma atualização do portal chegando agora. Recarregue a página; se continuar, avise o administrador do BI.</p>
        <button type="button" onClick={() => window.location.reload()}>Recarregar</button>
      </div>
    )
  }
}
